module.exports = __webpack_public_path__ + "static/media/Star.f4875d31.svg";